module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAhCAMAAADqFascAAAAe1BMVEUAAAD/AAC/AEDVACu/ICDMFCnKEiPQFCjMEybPECXODybPESbPECbOECbPEibPEibPECXOESTNEibOEiXOESbOEiXPEiXNEiXOESXOECXPESXOEibOESXOESXOESXOEiXOESXOESXOESXOESXOESXOESXOESXOESX///8UpF61AAAAJ3RSTlMAAgQGCBkdJigwQ0pQXmRlb3eAgoiRnp+nusPM0Nbc6e309vj8/f41RrN9AAAAAWJLR0QovbC1sgAAAGZJREFUKM/tz1USgDAMRdHg7u5O9r9Dpi3aYQdw/t79yQTgYLaVATwxnBGnQHhWtUSqUO7V7nHXWWeUE7ysicSqXuNDpZHqDMgZfYAMX6TgxVTDdsOWe5zNWc65d/781RwtpC7RPjfCsirGY1tkTwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/goTop.png
// module id = bLqV
// module chunks = 2